import React, { useEffect, useState } from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale } from "chart.js";
import { Line } from "react-chartjs-2";
import "chartjs-adapter-date-fns";
import { Card, Row, Spinner } from "react-bootstrap";
import { wait } from "../../../helpers/loading";

ChartJS.register(TimeScale, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

interface LineChartState {
  titleText: string;
  data?: any[];
  assessType?: any;
}

export const AssessmentLineChart = ({ titleText = "Overall Assessment", data, assessType }: LineChartState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [fetchedData, setFetchedData] = useState<any>();

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      await wait(250); // Simulate loading delay
      if (data) {
        setFetchedData(data);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [data]);

  const scale = assessType?.original?.question[0].fields.length - 1 || 10; // Default to 10 if scale is not provided

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const,
      },
      title: {
        display: true,
        text: titleText,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: scale,
      },
      x: {
        type: "time" as const,
        time: {
          unit: "month" as const,
          displayFormats: { month: "MMM yyyy" },
          tooltipFormat: "MMM d, yyyy",
        },
        ticks: {
          maxTicksLimit: 8, // Limit the number of ticks to prevent overcrowding
          maxRotation: 30, // Rotate labels at a 45-degree angle
        },
      },
    },
  };

  const chartData = {
    labels: fetchedData?.map((item: any) => item?.date),
    datasets: [
      {
        label: "Score",
        data: fetchedData?.map((item: any) => ({ x: item?.date, y: item?.score })),
        borderColor: "rgb(218 , 126 , 57)",
        backgroundColor: "rgba(218 , 126 , 57, 0.5)",
      },
    ],
  };

  if (isLoading) {
    return (
      <Card className="p-3">
        <Card.Body>
          <Row className="text-center">
            <span className="mt-2 mb-2">
              <Spinner animation="border" style={{ color: "#F6893D" }} />
            </span>
          </Row>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="p-3">
      <Line options={options} data={chartData} />
    </Card>
  );
};
